import Keycloak from 'keycloak-js'
import Auth from './auth'

export default class KeycloakAuth extends Auth {
  private keycloak: Keycloak
  private initPromise: Promise<void> | null = null

  constructor(url: string, realm: string, clientId: string) {
    super()

    this.keycloak = new Keycloak({
      url: url,
      realm: realm,
      clientId: clientId,
    })
  }

  async init(): Promise<void> {
    if (!this.initPromise) {
      this.initPromise = this.keycloak
        .init({
          onLoad: 'login-required',
          pkceMethod: 'S256',
          checkLoginIframe: false,
        })
        .then(() => undefined)
    }

    return this.initPromise
  }

  async resolveToken(): Promise<string> {
    await this.init()

    const token = this.keycloak.token
    if (!token) {
      throw new Error('Token is not available')
    }
    return token
  }

  async refreshToken(): Promise<void> {
    await this.init()

    try {
      await this.keycloak.updateToken(30)
    } catch {
      console.error('Token refresh failed')
      this.keycloak.logout()
    }
  }

  async logout(): Promise<void> {
    await this.keycloak.logout()
  }

  async getUserData(): Promise<{
    firstName: string
    lastName: string
    id: string
    email: string
    permissions: string[]
  }> {
    await this.init()
    const parsed = this.keycloak.tokenParsed
    if (!parsed) {
      throw new Error('Token is not available')
    }
    return {
      firstName: parsed['given_name'] ?? '',
      lastName: parsed['family_name'] ?? '',
      id: parsed['sub'] ?? '',
      email: parsed['email'] ?? '',
      permissions: parsed['realm_access']?.roles ?? [],
    }
  }
}
